import React from 'react';

type Props = {
    label: string;
    value: string;
    icon: JSX.Element;
};

export const StatisticContainer: React.FC<Props> = ({ label, icon, value }) => {
    return (
        <div className="statistic-container">
            <h2 className="stat-label">{label}</h2>
            <div className="stat-value-container">
                <div className="stat-icon">{icon}</div>
                <p className="stat-value">{value}</p>
            </div>
        </div>
    );
};
